import { Label } from 'semantic-ui-react'
import { SyncErrorClassification } from '../../../../actions/plaid/authActions'
import { PlaidConnectionStatus } from './helpers'

export { PlaidConnectionStatus, derivePlaidConnectionStatus } from './helpers'

const SYNC_ERROR_LABELS: Record<SyncErrorClassification, string> = {
  [SyncErrorClassification.REAUTH_REQUIRED]: 'Reconnection required',
  [SyncErrorClassification.TRANSIENT_RETRYABLE]:
    'Temporary error — retrying automatically',
  [SyncErrorClassification.PERMISSION_DENIED]: 'Account permissions issue',
  [SyncErrorClassification.INSTITUTION_UNSUPPORTED]:
    'Bank temporarily unavailable',
  [SyncErrorClassification.INTERNAL_FAILURE]: 'Internal sync error',
  [SyncErrorClassification.USER_SETUP_REQUIRED]: 'User setup required',
  [SyncErrorClassification.UNKNOWN_PLAID_ERROR]: 'Unknown Plaid Error',
}

export const PlaidConnectionLabel = ({
  status,
  syncErrorClassification,
}: {
  status: PlaidConnectionStatus
  syncErrorClassification: SyncErrorClassification | null
}) => {
  if (status === PlaidConnectionStatus.Inactive)
    return <Label horizontal>inactive</Label>
  if (status === PlaidConnectionStatus.Disconnected)
    return (
      <Label color="red" horizontal>
        Disconnected
      </Label>
    )
  if (status === PlaidConnectionStatus.LowFrequency)
    return (
      <>
        <Label color="green" horizontal>
          Connected
        </Label>
        <Label color="yellow" horizontal>
          Low frequency
        </Label>
      </>
    )
  if (status === PlaidConnectionStatus.SyncError) {
    const errorLabel = syncErrorClassification
      ? (SYNC_ERROR_LABELS[syncErrorClassification] ?? syncErrorClassification)
      : 'Sync error'
    const isTransient =
      syncErrorClassification === SyncErrorClassification.TRANSIENT_RETRYABLE
    return (
      <Label
        color={isTransient ? 'yellow' : 'red'}
        horizontal
        title={errorLabel}
      >
        <span className="inline-block align-middle max-w-[200px] truncate">
          {errorLabel}
        </span>
      </Label>
    )
  }
  return (
    <Label color="green" horizontal>
      Connected
    </Label>
  )
}
